import {createSelector} from 'reselect';

export const ugcSelectorFn = state => state.ugc;

export const qnaFilterDataSelector = state => state.ugc.qnaFilterData;
export const qnaDataSelector = state => state.ugc.qnaData;
export const pendingQnaDataSelector = state => state.ugc.pendingQnaData;

export const hasQnaData = state => state.ugc.hasQnaData;
export const hasQnaDataSelector = createSelector(hasQnaData, hasQnaData => hasQnaData);

export const qnaPaginatorStatusSelector = state => state.ugc.qnaPaginatorStatus;
export const rnrPaginatorStatus = state => state.ugc.paginatorStatus;

export const qnaDetailTypeSelector = state => state.ugc.qnaDetailType;
export const newQuestionsSelector = state => state.ugc.newQuestions;
export const selQNATagIdsSelector = state => state.ugc.selTagIds;
export const selRnrTagIds = createSelector(ugcSelectorFn, ugcData => ugcData?.selRnrTagIds || []);

export const snapData = state => state.ugc.snapData;

// export const snapDataSelector = state => state.ugc.snapData;
export const snapDataSelector = createSelector(ugcSelectorFn, ugcData => ugcData?.snapData || {});
export const giSnapData = createSelector(snapData, snapDataObject => snapDataObject?.giData || {});
export const recentReviewsRatingSelector = createSelector(
  giSnapData,
  giSnapDataObject => giSnapDataObject?.recentWindowRating,
);
export const recentReviewsCountSelector = createSelector(
  giSnapData,
  giSnapDataObject => giSnapDataObject.recentReviewCount,
);

export const selectedRnRType = state => state.ugc.selectedRnRType;
export const selectedRnRTypeSelectorFn = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.selectedRnRType || '',
);

export const isUgcChipSelectedSelector = createSelector(
  ugcSelectorFn,
  ugcData => ugcData.isUgcChipSelected,
);

export const rnrImagesSelector = createSelector(ugcSelectorFn, data => {
  var rnrImages = data?.rnrImages?.map(function(item) {
    return {
      imgSrc: item?.bigUrl,
    };
  });
  return rnrImages;
});

export const hasDataSelector = state => state.ugc.hasData;
export const hasSnapDataSelector = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.hasData || false,
);

export const pendingReviewData = state => state.ugc.pendingReviewData;
export const pendingReviewDataSelector = createSelector(
  pendingReviewData,
  pendingReviewData => pendingReviewData,
);

export const hasReviewData = state => state.ugc.hasReviewData;
export const hasReviewDataSelector = createSelector(hasReviewData, hasReviewData => hasReviewData);

export const reviewData = state => state.ugc.reviewData;
export const reviewDataSelector = createSelector(reviewData, reviewData => reviewData);

export const reviewDetailType = state => state.ugc.reviewDetailType;
export const reviewDetailTypeSelector = createSelector(reviewDetailType, item => item);

export const taTagData = state => state.ugc.snapData?.taData?.hdpTags || [];
export const taTagDataSelector = createSelector(taTagData, taTagData => taTagData);

export const giTagData = state => state.ugc.snapData?.giData?.hdpTags || [];
export const giTagDataSelector = createSelector(giTagData, giTagData => giTagData);

export const hasMoreImagesSelector = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.hasMoreImages || false,
);

export const userReviewsLoadingState = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.loadingUserReviews,
);

export const moreUgcImages = createSelector(ugcSelectorFn, ugcData => ugcData?.moreUgcImages || []);

export const ugcImagesSelector = createSelector(moreUgcImages, moreUgcImages => {
  var ugcImages = moreUgcImages.map(function(item) {
    return {
      imgSrc: item?.bigUrl,
      thumbnailSrc: item?.thumbUrl,
      overlayData: {
        tag: item.tags?.[0],
      },
    };
  });
  return ugcImages;
});

export const selectedGalleryTabSelector = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.selectedGalleryTab,
);

export const fetchSnapDataStatusSelector = createSelector(
  ugcSelectorFn,
  ugcData => ugcData?.fetchSnapDataStatus,
);
